export type CampaignCheckingAccountLink = {
  checking_account_id: string
  priority: number
}

/**
 * Maps a selected Insertion Order to the campaign create funding payload.
 * Returns [] when `checking_account_id` is missing — callers must block submit.
 */
export const buildCheckingAccountsFromInsertionOrder = (
  insertionOrder: InsertionOrder
): CampaignCheckingAccountLink[] => {
  const checkingAccountId = insertionOrder?.checking_account_id

  if (!checkingAccountId) {
    return []
  }

  return [
    {
      checking_account_id: checkingAccountId,
      priority: 1
    }
  ]
}
